module.exports = __WEBPACK_EXTERNAL_MODULE_mk_app_loader__;